import BlogGridView from "../../../commonComponents/blogGridView";

const BlogLeftListContainer = () => {
  return <BlogGridView sectionClass="blog-list-section" gridSize={1} />;
};

export default BlogLeftListContainer;
